function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 3.9,
  cy: 9,
  r: 2.5,
  strokeWidth: 1.5,
  fill: "none",
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2,
  cy: 3.9,
  r: 2.5,
  strokeWidth: 1.5,
  fill: "none",
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2,
  cy: 14.1,
  r: 2.5,
  strokeWidth: 1.5,
  fill: "none",
  stroke: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 11.9,
  y1: 5,
  x2: 6.1,
  y2: 7.9,
  strokeWidth: 1.5,
  fill: "none",
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 11.9,
  y1: 13,
  x2: 6.1,
  y2: 10.1,
  strokeWidth: 1.5,
  fill: "none",
  stroke: "currentColor"
});

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share_svg__share_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgShare;